export const ROUTES = { home: '/', blog: '/blog', projectDetail: '/project-detail' } as const;

export function projectPath(slug: string): string {
  return `${ROUTES.projectDetail}/${slug}`;
}

export function blogPath(slug: string): string {
  return `${ROUTES.blog}/${slug}`;
}
